<template>
    <page-sidebar :links="links" :bold="false"></page-sidebar>
</template>

<script setup>
import PageSidebar from '~/components/general/PageSidebar.vue';
import { settingsLinks } from '~/composables/settingsLinks';

const links = settingsLinks();
</script>
